import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useConfirmation = () => useSelector(store, (state) => state.context.confirmation);
